// state is not the application state, only the state this
// reducer is responsible for.
import { CLUE_SELECTED } from "../constants/ActionTypes";

// Returns a Clue object
export default function (state = null, action) {

    switch (action.type) {
        case CLUE_SELECTED:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_active_clue.js